var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CustomerStatus, LINKS, goTo } from '@raisin/cp-utils';
import { trackEvent } from '@raisin/events-tracking';
import { EVENTS } from '../../../eventsTracking';
const isMissingReferenceAccount = (customer) => {
    var _a, _b;
    const referenceAccount = (_b = (_a = customer === null || customer === void 0 ? void 0 : customer._embedded) === null || _a === void 0 ? void 0 : _a.referenceAccounts) === null || _b === void 0 ? void 0 : _b[0];
    return !(referenceAccount === null || referenceAccount === void 0 ? void 0 : referenceAccount.iban);
};
const isCustomerActive = (customer) => (customer === null || customer === void 0 ? void 0 : customer.status) === CustomerStatus.Active;
export const shouldRedirectCustomerToUpdateReferenceAccount = (customer) => !!customer && isCustomerActive(customer) && isMissingReferenceAccount(customer);
export const redirectCustomerToUpdateReferenceAccount = () => __awaiter(void 0, void 0, void 0, function* () {
    yield trackEvent(EVENTS.CUSTOMER_REDIRECTED_TO_REFERENCE_ACCOUNT);
    goTo(LINKS.CUSTOMER.INITIAL_REFERENCE_ACCOUNT);
});
//# sourceMappingURL=initialReferenceAccount.js.map